import { ComboboxOption } from '@headlessui/react'
import React from 'react'
import { AlgoliaSearchResult } from '../../../hooks/useAlgoliaSearch'
import { IconResult } from './IconResult'
import { LogoResult } from './LogoResult'

interface ItemResultProps {
  result: AlgoliaSearchResult
}

const OfferResult = ({ result }: ItemResultProps) => <ComboboxOption
  as="li"
  key={result.objectID}
  value={result.url}
  className="flex items-center px-3 py-2 rounded-md cursor-pointer select-none hover:bg-light-blue/20 group data-focus:bg-indigo-600 data-focus:text-white data-focus:outline-hidden"
>
  <LogoResult logo={result.logo} name={result.name} />
  <div className="flex-auto ml-3">
    <p className="text-xs truncate md:text-sm text-night">
      {result.highlightResult?.name?.value || result.name}
    </p>
  </div>
  <div className='flex items-center space-x-2'>
    <IconResult type={result.type} />
    <span className="flex-none ml-3 text-xs text-gray-500 group-data-focus:text-indigo-100">
      Offre
    </span>
  </div>
</ComboboxOption>

const FirmResult = ({ result }: ItemResultProps) => <ComboboxOption
  as="li"
  key={result.objectID}
  value={result.url}
  className="flex items-center px-3 py-2 rounded-md cursor-pointer select-none hover:bg-light-blue/20 group data-focus:bg-indigo-600 data-focus:text-white data-focus:outline-hidden"
>
  <LogoResult logo={result.logo} name={result.name} />
  <div className="flex-auto ml-3">
    <p className="mt-1 text-xs truncate md:text-sm text-night">
      {result.highlightResult?.name?.value || result.name}
    </p>
  </div>
  <div className='flex items-center space-x-2'>
    <span className="flex-none ml-3 text-xs text-gray-500 group-data-focus:text-indigo-100">
      Cabinet
    </span>
  </div>
</ComboboxOption>

export const ItemResult = ({ result }: ItemResultProps) => {
  if (!result) {
    return null
  }
  switch (result.type) {
    case 'offer':
      return <OfferResult result={result} />
    case 'firm':
      return <FirmResult result={result} />
    default:
      return null
  }
}
